import { createFileRoute } from '@tanstack/react-router';

import { DidMappingListScreen } from '@/features/telephony/components/DidMappingListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/telephony/did-mappings')({
  beforeLoad: () => {
    requirePermission('did_mapping:read');
  },
  // Platform surface: super admins manage numbers across every BA.
  component: PlatformDidMappingsRoute,
  staticData: { crumb: 'Helpline numbers' },
});

function PlatformDidMappingsRoute() {
  return <DidMappingListScreen surface="platform" />;
}
